module.exports = __webpack_public_path__ + "img/zg-nongyebank.4cf4fb57.png";